module.exports = __webpack_public_path__ + "static/media/plus.c5597518.svg";